// extracted by mini-css-extract-plugin
module.exports = {"commLayout":"Layout_commLayout__cdKOM","commContent":"Layout_commContent__OS8rn","headerLayout":"Layout_headerLayout__1A7aS","footerLayout":"Layout_footerLayout__SJLDM"};